import { RootState } from "app/store";
import { EControlType } from "components/ControlWrapper";
import { calcFieldName, friendlyValue } from "global/Application";
import { Constants } from "global/Application/Constants";
import { AppDataSource } from "global/DataSources/AppDataSource";
import {
    $att_$non_standard_$bcbs_applymaximumper_id,
    $att_$non_standard_$bcbs_aremaximumsarecombinedinandoutofnetwork_id,
    $att_$non_standard_$bcbs_benefitdefinition_id,
    $att_$non_standard_$bcbs_benefitflip100whenoopmax_id,
    $att_$non_standard_$bcbs_benefitscontributetooutofpocketmax_id,
    $att_$non_standard_$bcbs_contributestooutofpocketmaximumscomments_id,
    $att_$non_standard_$bcbs_doesthisbenefitpayaccoridngtotherelatedbe_id,
    $att_$non_standard_$bcbs_dollarlimit_id,
    $att_$non_standard_$bcbs_effectivedate_id,
    $att_$non_standard_$bcbs_eventoritemlimit_id,
    $att_$non_standard_$bcbs_maximumother_id,
    $att_$non_standard_$bcbs_nonstandardexclude_id,
    $att_$non_standard_$bcbs_nonstandardinclude_id,
    $att_$non_standard_$bcbs_paymentlevel_id,
    $att_$non_standard_$bcbs_paymentleveloon_id,
    $att_$non_standard_$bcbs_preauthrequired_id,
    $att_$non_standard_$bcbs_preauthrequiredother_id,
    $att_$non_standard_$bcbs_realtestocoverage_id,
} from "model/ConfigAttributeConstants";
import { bcbs_config_attribute, bcbs_config_section } from "model/CRM";
import {
    IAccountsReceivable as FAM_IAccountsReceivable,
    IBenefit as FAM_IBenefit,
    IFeesAndPremiums as FAM_IFeesAndPremiums,
    IGroupConfigurationData as FAM_IGroupConfigurationData,
    INonStandard as FAM_INonStandard,
    IPlan as FAM_IPlan,
    IStopLoss as FAM_IStopLoss,
    ITierLevel as FAM_ITierLevel
} from "model/FlexibleAttributeModel";
import { EColumnExtractDataTypes } from "./EColumnExtractDataTypes";
import { IColumnExtract } from "./IColumnExtract.type";
import { IDatasetExtract } from "./IDatasetExtract";
import { IRowExtract } from "./IRowExtract.type";

interface INonstandardToRowScope {
    groupConfig: FAM_IGroupConfigurationData;
    plan?: FAM_IPlan;
    benefit?: FAM_IBenefit;
    accountsReceivable?: FAM_IAccountsReceivable;
    feesAndPremiums?: FAM_IFeesAndPremiums;
    stopLoss?: FAM_IStopLoss;
    nonStandard: FAM_INonStandard;
}

interface INonstandardColumnTag {
    config: {
        bcbs_config_attribute: bcbs_config_attribute;
        bcbs_config_section: bcbs_config_section;
        tierSortOrder: number;
    }
}



export default async function NonstandardExcelExtract(state: RootState, dataSource: AppDataSource) {


    // Nonstandard attribute sort order based on bcbs_viewsortorder from CRM fetch XML query
    // https://bcbsonlinesys.crm.dynamics.com/api/data/v9.1/bcbs_config_attributes?fetchXml=%3Cfetch%20xmlns%3Agenerator%3D%27MarkMpn.SQL4CDS%27%3E%0A%20%20%3Centity%20name%3D%27bcbs_config_attribute%27%3E%0A%20%20%20%20%3Cattribute%20name%3D%27bcbs_viewsortorder%27%20%2F%3E%0A%20%20%20%20%3Cattribute%20name%3D%27bcbs_config_attributeid%27%20%2F%3E%0A%20%20%20%20%3Cattribute%20name%3D%27bcbs_name%27%20%2F%3E%0A%20%20%20%20%3Clink-entity%20name%3D%27bcbs_config_section%27%20to%3D%27bcbs_config_sectionid%27%20from%3D%27bcbs_config_sectionid%27%20alias%3D%27bcbs_config_section%27%20link-type%3D%27inner%27%20%2F%3E%0A%20%20%20%20%3Cfilter%3E%0A%20%20%20%20%20%20%3Ccondition%20attribute%3D%27bcbs_nonstandard%27%20operator%3D%27eq%27%20value%3D%271%27%20%2F%3E%0A%20%20%20%20%3C%2Ffilter%3E%0A%20%20%20%20%3Corder%20attribute%3D%27bcbs_viewsortorder%27%20%2F%3E%0A%20%20%3C%2Fentity%3E%0A%3C%2Ffetch%3E
    const NONSTANDARD_ATTRIBUTE_SORT_ORDER: Record<string, number> = {
        [$att_$non_standard_$bcbs_effectivedate_id]: 1100,
        [$att_$non_standard_$bcbs_benefitdefinition_id]: 1200,
        [$att_$non_standard_$bcbs_realtestocoverage_id]: 1300,
        [$att_$non_standard_$bcbs_doesthisbenefitpayaccoridngtotherelatedbe_id]: 1400,
        [$att_$non_standard_$bcbs_nonstandardinclude_id]: 1500,
        [$att_$non_standard_$bcbs_nonstandardexclude_id]: 1600,
        [$att_$non_standard_$bcbs_preauthrequired_id]: 1700,
        [$att_$non_standard_$bcbs_contributestooutofpocketmaximumscomments_id]: 1800,
        [$att_$non_standard_$bcbs_preauthrequiredother_id]: 1900,
        [$att_$non_standard_$bcbs_dollarlimit_id]: 2100,
        [$att_$non_standard_$bcbs_eventoritemlimit_id]: 2200,
        [$att_$non_standard_$bcbs_applymaximumper_id]: 2300,
        [$att_$non_standard_$bcbs_aremaximumsarecombinedinandoutofnetwork_id]: 2400,
        [$att_$non_standard_$bcbs_maximumother_id]: 2500,
        [$att_$non_standard_$bcbs_paymentlevel_id]: 2600,
        [$att_$non_standard_$bcbs_paymentleveloon_id]: 2700,
        [$att_$non_standard_$bcbs_benefitscontributetooutofpocketmax_id]: 2800,
        [$att_$non_standard_$bcbs_benefitflip100whenoopmax_id]: 2900,
    };

    const rows: IRowExtract[] = [];
    const columns: Record<string, IColumnExtract<INonstandardColumnTag>> = {};
    let columnIX = 0;

    function nonStandardToRow(
        scope: INonstandardToRowScope
    ) {
        const { nonStandard } = scope;

        const row: Record<string, string> = {};

        const tierNames = scope?.benefit?.tiers?.reduce((prev, curr) => {
            prev[curr.id] = curr;
            return prev;
        }, {} as Record<string, FAM_ITierLevel>) ?? {};

        row.status = "Active";

        if (nonStandard.deactivated)
            row.status = "Inactive Nonstandard";

        if (scope.benefit?.deactivated)
            row.status = "Inactive Benefit";

        if (scope.accountsReceivable?.deactivated)
            row.status = "Inactive Accounts Receivable";

        if (scope.feesAndPremiums?.deactivated)
            row.status = "Inactive Fees and Premiums";

        if (scope.stopLoss?.deactivated)
            row.status = "Inactive Stop Loss";

        // Identity columns are always set regardless of whether fields have values
        row.id = nonStandard.id;
        row.plan = scope?.plan?.name ?? "";
        row.name = nonStandard.name;
        row.partOfTemplate = nonStandard.partOfTemplate === true ? "yes" : "";
        row.referenceOnly = nonStandard.referenceOnly === true ? "yes" : "";
        row.scope = "";

        if (scope.groupConfig && !scope.benefit && !scope.accountsReceivable && !scope.feesAndPremiums && !scope.stopLoss)
            row.scope = "Group Configuration";

        if (scope.benefit)
            row.scope = "Benefit";

        if (scope.accountsReceivable)
            row.scope = "Accounts Receivable";

        if (scope.feesAndPremiums)
            row.scope = "Fees and Premiums";

        if (scope.stopLoss)
            row.scope = "Stop Loss";

        row.benefitCategory = scope?.benefit?.bcbs_name ?? "";
        row.benefitName = scope?.benefit?.name ?? "";

        // For AR, F&P, and Stop Loss, use their name in dedicated columns
        row.arName = scope?.accountsReceivable?.name ?? "";
        row.fpName = scope?.feesAndPremiums?.name ?? "";
        row.slName = scope?.stopLoss?.name ?? "";

        row.section = nonStandard.sectionRef?.name ?? '';

        if (nonStandard?.sectionRef?.id) {
            const sect = state.data.config.cache.map_bcbs_config_section[nonStandard.sectionRef.id];
            if (sect?._bcbs_config_tabid_value) {
                const tab = state.data.config.cache.map_bcbs_config_tab[sect._bcbs_config_tabid_value!];
                if (tab)
                    row.tab = tab.bcbs_name!;
            }
        }

        nonStandard.fields.forEach(eachField => {

            const configAttribute = state.data.config.cache.map_bcbs_config_attribute[eachField.configRef.id];
            if (!configAttribute) return;

            const masterAttribute = state.data.config.cache.map_bcbs_config_masterattribute[configAttribute._bcbs_config_masterattributeid_value!];
            if (!masterAttribute) return;

            const configSection = state.data.config.cache.map_bcbs_config_section[configAttribute._bcbs_config_sectionid_value!];

            const controlType = masterAttribute.bcbs_attributetypecode as EControlType;

            eachField.values.forEach(eachFieldValue => {

                const ffValue = eachFieldValue.value;

                let fieldName = calcFieldName(eachField, eachFieldValue, configAttribute, tierNames, false);
                let value = ffValue ? friendlyValue(controlType, ffValue) : '';
                row[fieldName] = value;

                // if column does not exist, add
                const col = columns[fieldName];

                const tier: FAM_ITierLevel | null = tierNames && eachFieldValue.tierRef?.id
                    ? tierNames[eachFieldValue.tierRef.id]
                    : null;

                if (!col) {
                    columns[fieldName] = {
                        attributeId: configAttribute.bcbs_config_attributeid!,
                        order: configAttribute.bcbs_viewsortorder ?? 0,
                        _temp: {
                            config: {
                                bcbs_config_attribute: configAttribute,
                                bcbs_config_section: configSection,
                                tierSortOrder: tier?.bcbs_sortorder ?? 0,
                            },
                        },
                        width: configAttribute.bcbs_viewcolumnwidth ?? 45,
                        index: ++columnIX,
                        fieldName: fieldName,
                        hidden: false,
                        name: fieldName,
                        dataType: controlType === EControlType.currency
                            ? EColumnExtractDataTypes.Currency
                            : EColumnExtractDataTypes.Default
                    };
                }
            });
        });
        return row;
    }

    columns['id'] = {
        attributeId: '',
        order: 1,
        width: 25,
        index: ++columnIX,
        fieldName: 'id',
        hidden: true,
        name: 'ID',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['plan'] = {
        attributeId: '',
        order: 2,
        width: 25,
        index: ++columnIX,
        fieldName: 'plan',
        hidden: false,
        name: 'Plan',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['scope'] = {
        attributeId: '',
        order: 3,
        width: 18,
        index: ++columnIX,
        fieldName: 'scope',
        hidden: false,
        name: 'Scope',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['benefitCategory'] = {
        attributeId: '',
        order: 4,
        width: 18,
        index: ++columnIX,
        fieldName: 'benefitCategory',
        hidden: false,
        name: 'Benefit Category',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['benefitName'] = {
        attributeId: '',
        order: 5,
        width: 38,
        index: ++columnIX,
        fieldName: 'benefitName',
        hidden: false,
        name: 'Benefit Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['arName'] = {
        attributeId: '',
        order: 6,
        width: 38,
        index: ++columnIX,
        fieldName: 'arName',
        hidden: false,
        name: 'Accounts Receivable Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['fpName'] = {
        attributeId: '',
        order: 7,
        width: 38,
        index: ++columnIX,
        fieldName: 'fpName',
        hidden: false,
        name: 'Fees and Premiums Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['slName'] = {
        attributeId: '',
        order: 8,
        width: 38,
        index: ++columnIX,
        fieldName: 'slName',
        hidden: false,
        name: 'Stop Loss Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['tab'] = {
        attributeId: '',
        order: 9,
        width: 25,
        index: ++columnIX,
        fieldName: 'tab',
        hidden: false,
        name: 'Tab',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['section'] = {
        attributeId: '',
        order: 10,
        width: 18,
        index: ++columnIX,
        fieldName: 'section',
        hidden: false,
        name: 'Section',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['status'] = {
        attributeId: '',
        order: 11,
        width: 10,
        index: ++columnIX,
        fieldName: 'status',
        hidden: false,
        name: 'Status',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['name'] = {
        attributeId: '',
        order: 12,
        width: 26,
        index: ++columnIX,
        fieldName: 'name',
        hidden: false,
        name: 'Non-Standard Name',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['referenceOnly'] = {
        attributeId: '',
        order: 13,
        width: 26,
        index: ++columnIX,
        fieldName: 'referenceOnly',
        hidden: false,
        name: 'ReferenceOnly',
        dataType: EColumnExtractDataTypes.Default,
    };

    columns['partOfTemplate'] = {
        attributeId: '',
        order: 14,
        width: 26,
        index: ++columnIX,
        fieldName: 'partOfTemplate',
        hidden: false,
        name: 'Templated',
        dataType: EColumnExtractDataTypes.Default,
    };

    state.data.json.benefits.forEach(eachBenefit => {

        const benefitPlans = state.data.json.plans.filter(eachPlan => eachPlan.benefitRefs.find(q => q.id === eachBenefit.id));

        // benefit part of a plan, we need to duplicate
        if (benefitPlans?.length > 0)
            benefitPlans.forEach(eachPlan => {
                eachBenefit.nonStandards.forEach(eachNS => {
                    const row = nonStandardToRow({ plan: eachPlan, benefit: eachBenefit, groupConfig: state.data.json, nonStandard: eachNS });
                    rows.push(row);
                });
            });
        else
            eachBenefit.nonStandards.forEach(eachNS => {
                const row = nonStandardToRow({ benefit: eachBenefit, groupConfig: state.data.json, nonStandard: eachNS });
                rows.push(row);
            });

    });

    // Process Accounts Receivable
    state.data.json.claimsARs?.forEach(eachAR => {
        eachAR.nonStandards?.forEach(eachNS => {
            const row = nonStandardToRow({ accountsReceivable: eachAR, groupConfig: state.data.json, nonStandard: eachNS });
            rows.push(row);
        });
    });

    // Process Fees and Premiums
    state.data.json.feesAndPremiums?.forEach(eachFP => {
        eachFP.nonStandards?.forEach(eachNS => {
            const row = nonStandardToRow({ feesAndPremiums: eachFP, groupConfig: state.data.json, nonStandard: eachNS });
            rows.push(row);
        });
    });

    // Process Stop Loss
    state.data.json.stopLoss?.forEach(eachSL => {
        eachSL.nonStandards?.forEach(eachNS => {
            const row = nonStandardToRow({ stopLoss: eachSL, groupConfig: state.data.json, nonStandard: eachNS });
            rows.push(row);
        });
    });

    // Process Group Configuration level non-standards
    state.data.json.nonStandards.forEach(eachNS => {
        const row = nonStandardToRow({ groupConfig: state.data.json, nonStandard: eachNS });
        rows.push(row);
    });

    // Apply the selected attribute ordering, falling back to configured order for other attributes.
    const columnsArray = Object.entries(columns)
        .map(([, eachColumn]) => {
            const configAttribute = eachColumn._temp?.config?.bcbs_config_attribute;

            // loading from static lookup, older releases may not have bcbs_viewsortorder set
            if (configAttribute) {
                let order = configAttribute.bcbs_viewsortorder ?? eachColumn.order;

                // Determine if we should use the static sort order based on the release creation date
                // Use static sort order for non-standard attributes if the configuration was created before the time that update was applied.
                if (state.data.config.createdOnTime < Constants.data.nonStandardStaticColumnSortTime)
                    order = NONSTANDARD_ATTRIBUTE_SORT_ORDER[configAttribute.bcbs_config_attributeid!]

                eachColumn.order = (order * 1000) + (eachColumn._temp?.config?.tierSortOrder ?? 0);
            }

            // Remove the tag property after calculating the order to avoid including it in the final column object
            delete eachColumn._temp;

            return eachColumn;
        })
        .sort((a, b) => a.order - b.order);

    const dataSet: IDatasetExtract = {
        name: '',
        tables: [
            {
                columns: columnsArray,
                data: rows,
                name: "Non-Standards"
            }
        ],
        dropDownTables: null
    }

    console.log('NonstandardExcelExtract DataSet:', dataSet);

    const getNonstandardExtractAsync = await dataSource.getGenerateExcelExtract(dataSet);
    return getNonstandardExtractAsync;

}